import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AngularMaterialModule } from 'src/app/external-components/angular-material.module';
import { CommonModule } from '@angular/common';
import { ExecutionListComponent } from './execution-list/execution-list.component';
import { ExecutionListFilterComponent } from './execution-list/execution-list-filter.component';
import { FlexLayoutModule } from 'ng-flex-layout';
import { NgModule } from '@angular/core';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ExecutionListComponent, ExecutionListFilterComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,

    /* Custom modules */
    AngularMaterialModule,
    SharedModule,
    PipesModule,

    /* Otros */
    FlexLayoutModule,
    RouterModule
  ],
  exports: [ExecutionListComponent, ExecutionListFilterComponent, SharedModule]
})
export class ThermalModule { }
